<ng-template #tipMention>
  <div class="max-w-[306px] flex flex-row flex-nowrap items-center">
    <mi-avatar
      class="flex-shrink-0 min-w-8 min-h-8"
      [hash]="userId() | hash"
      [name]="getDisplayName()"
      [initials]="getDisplayName() | initials"
      [photoUrl]="
        chatAdminService.avatars[userId()]?.hasOwnProperty('50') ? chatAdminService.avatars[userId()][50] : ''
      "
    ></mi-avatar>
    @if (getEmail()) {
      <span class="ml-2 text-sm truncate min-w-0">{{ getEmail() }}</span>
    }
  </div>
</ng-template>

@if (isCustomElement()) {
  <span
    role="button"
    tabindex="0"
    (click)="mentionClick()"
    (keydown.enter)="mentionClick()"
    (keydown.space)="$event.preventDefault(); mentionClick()"
    class="mention rounded cursor-pointer px-1.5 py-0.5 mx-0.5 inline-block leading-3 font-bold"
    [ngClass]="{ 'cursor-default': disableTooltip() }"
    [ngStyle]="{
      'background-color': foundDisplayName() ? 'var(--p-primary-500)' : '',
      'color': foundDisplayName() ? 'var(--p-surface-0)' : ''
    }"
    [attr.contenteditable]="false"
    [pTooltip]="foundDisplayName() && !disableTooltip() ? tipMention : ''"
    tooltipPosition="top"
    tooltipStyleClass="mention-tooltip"
    [autoHide]="false"
    tooltipEvent="both"
    >&#64;{{ getDisplayName() }}</span
  >
} @else {
  <span
    role="button"
    tabindex="0"
    (click)="mentionClick()"
    (keydown.enter)="mentionClick()"
    (keydown.space)="$event.preventDefault(); mentionClick()"
    appendTo="body"
    class="mention rounded cursor-pointer px-1.5 py-2 mx-0.5 inline-block leading-3 font-bold"
    [ngClass]="{ 'cursor-default': disableTooltip() }"
    [ngStyle]="{
      'background-color': foundDisplayName() ? 'var(--p-primary-500)' : '',
      'color': foundDisplayName() ? 'var(--p-surface-0)' : ''
    }"
    [attr.contenteditable]="false"
    [pTooltip]="foundDisplayName() && !disableTooltip() ? tipMention : ''"
    tooltipPosition="top"
    tooltipStyleClass="mention-tooltip"
    [autoHide]="false"
    tooltipEvent="both"
    >&#64;{{ getDisplayName() }}</span
  >
}
